module.exports = __webpack_public_path__ + "img/丝路文博网_03.b80f2bc0.jpg";